import {createRouter, createWebHistory} from 'vue-router'
import BotDeploy from "@/views/BotDeploy.vue";

const routes = [
    {
        path: '/',
        name: 'bot',
        component: BotDeploy
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
